import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { setObstructionEditPointAction } from 'store/slices/ToolSlice';
import { OBS_EDIT_POINT_ACTION } from 'store/slices/ToolSlice/types';
import { CheckToggle } from './style';

const PointActions = [
	{ label: 'Add', val: OBS_EDIT_POINT_ACTION.ADD_POINT },
	{ label: 'Delete', val: OBS_EDIT_POINT_ACTION.DELETE_POINT },
];

export default function EditObstructionPointsOptionsStrip() {
	const { obstructionEditPointAction, selectedObstructionId, editedObstructions, manualObs } =
		useSelector((state: RootState) => state.toolNewPostions.data);

	const { obstructions } = useSelector((state: RootState) => state.roofData.data);

	const dispatch = useDispatch();

	const selectedPointsCount = useMemo(() => {
		if (!selectedObstructionId) return null;

		const manual = manualObs[selectedObstructionId];
		if (manual) return manual.coordinates.flat().length / 2;

		const obs = obstructions.find((item) => item.id === selectedObstructionId);
		if (!obs) return null;

		const edited = editedObstructions?.[obs.id];
		const coords = edited?.coordinates ?? obs.coordinates;

		return coords.flat().length / 2;
	}, [editedObstructions, manualObs, obstructions, selectedObstructionId]);

	const disableDelete = selectedPointsCount !== null && selectedPointsCount <= 3;

	const selectAction = (action: OBS_EDIT_POINT_ACTION) => {
		if (disableDelete && action === OBS_EDIT_POINT_ACTION.DELETE_POINT) return;
		if (action === obstructionEditPointAction) return;

		dispatch(setObstructionEditPointAction({ actionType: action }));
	};
	const activeIndex = PointActions.findIndex(
		(a) => a.val === obstructionEditPointAction
	);
	const isActiveDisabled =
  obstructionEditPointAction === OBS_EDIT_POINT_ACTION.DELETE_POINT &&
  disableDelete;

	return (
		<CheckToggle data-index={activeIndex} style={{ '--index': activeIndex } as React.CSSProperties}
			data-disabled={isActiveDisabled ? 'true' : 'false'}>
				
			<div className="slider" />

			{PointActions.map((action) => (
				<label key={action.val} className="check-control">
					<input
						id={`obs-checkbox-${action.val}`}
						type="radio"
						name="obs-toggle"
						checked={action.val === obstructionEditPointAction}
						onChange={() => selectAction(action.val)}
						disabled={
							action.val === OBS_EDIT_POINT_ACTION.DELETE_POINT &&
							disableDelete
						}
					/>
					<span className="check-mark">{action.label}</span>
				</label>
			))}
		</CheckToggle>
	);
}